import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {UserService} from '../../services/user.service';
import {CaseProcedureDataModel} from '../../models/caseProcedures/case-procedure-data.model';
import {DataPatientCaseWorkItemModel} from '../../models/accountsReceivable/data-patient-case-work-item.model';
import {cfgCaseProcedure, dataARClaim, enumValidValueItem} from '../ar/_models/ar.models';
import {FormConfigurationModel} from '../../models/forms/form-configuration.model';
import {cfgTooth} from '../tdo-shared/tooth-picker/tooth-picker.models';
import {PatientCaseWorkItemFormDataModel} from '../../models/forms/data/patient-case-work-item-form-data.model';
import {PassedPatientCaseWorkItemEventModel} from './models/passed-patient-case-work-item-event';
import {DataPatientCaseWorkItemEventModel} from '../../models/accountsReceivable/data-patient-case-work-item-event';
import {Globals} from '../../globals';
import {DataPatientCaseWorkItemToothModel} from '../../models/teeth/data-patient-case-work-item-tooth.model';

@Injectable({
  providedIn: 'root'
})
export class CaseFormsService {
  constructor(private http: HttpClient, private globals: Globals) { }

  getTeeth(groupingEnum: string): Observable<cfgTooth[]> {
    return this.http.get<cfgTooth[]>(`/api/tooth-config/get-all-teeth/${groupingEnum}`);
  }

  getCaseWorkItemTeeth(caseWorkItemId: string): Observable<DataPatientCaseWorkItemToothModel[]> {
    return this.http.get<DataPatientCaseWorkItemToothModel[]>(`api/cases/get-case-work-item-teeth/${caseWorkItemId}`);
  }

  getCaseWorkItemDoctor(caseWorkItemId: string): Observable<number> {
    return this.http.get<number>(`api/cases/get-case-work-item-doctor/${caseWorkItemId}`);
  }

  // By default this only grabs approved.
  getCfgDFormsAll(isIncludeInReview: boolean = false): Observable<FormConfigurationModel[]> {
    return this.http.post<FormConfigurationModel[]>(`/api/cases/get-cfgdforms-all`, {isIncludeInReview});
  }

  getCfgSchedulePatientFormsAll(LOCID: number): Observable<FormConfigurationModel[]> {
    return this.http.get<FormConfigurationModel[]>(`/api/cases/get-cfg-schedule-patient-forms-all/${LOCID}`);
  }

  getProcedureDFormsByCaseWorkItem(CaseWorkItemID: string): Observable<FormConfigurationModel[]> {
    return this.http.get<FormConfigurationModel[]>(`/api/cases/getProcedureDFormsByCaseWorkItem/${CaseWorkItemID}`);
  }

  getDFormIDsByCaseWorkItem(CaseWorkItemID: string): Observable<string[]> {
    return this.http.get<string[]>(`/api/cases/getDFormIDsByCaseWorkItem/${CaseWorkItemID}`);
  }

  getEnums_CaseItemStatus(): Observable<enumValidValueItem[]> {
    return this.http.get<enumValidValueItem[]>(`/api/cases/getEnumsCaseItemStatus`);
  }

  getEnums_CaseItemFormStatus(): Observable<enumValidValueItem[]> {
    return this.http.get<enumValidValueItem[]>(`/api/cases/getEnumsCaseItemFormStatus`);
  }

  getEnums_CaseItemFormFilledBy(): Observable<enumValidValueItem[]> {
    return this.http.get<enumValidValueItem[]>(`/api/cases/getEnumsCaseItemFormFilledBy`);
  }
//
  getPatientForms(PatientId: string): Observable<PatientCaseWorkItemFormDataModel[]> {
    if(PatientId === null || PatientId === undefined || PatientId === '' || PatientId === 'null'){
      return new Observable<PatientCaseWorkItemFormDataModel[]>();
    }
    return this.http.get<PatientCaseWorkItemFormDataModel[]>(`/api/get-patient-general-forms/${PatientId}`);
  }
  
  getPatientRepoForms(PatientId: string): Observable<PatientCaseWorkItemFormDataModel[]> {
    debugger;
    // Check that the PatientId is not null, empty, or invalid
    if (PatientId === null || PatientId === undefined || PatientId === '' || PatientId === 'null') {
      return new Observable<PatientCaseWorkItemFormDataModel[]>();
   }
    // Make the request to the new endpoint
    return this.http.get<PatientCaseWorkItemFormDataModel[]>(`/api/get-patient-repo-forms/${PatientId}`);
  }

  getPatientFormsCaseWorkItemID(locId: string, patientId: string): Observable<string> {
    if(patientId === null || patientId === undefined || patientId === '' || patientId === 'null'){
      return new Observable<string>();
    }

    return this.http.get<string>(`/api/get-patient-general-forms-case-work-item-id/${locId}/${patientId}`);
  }

  getPatientFormsCaseWorkItem(locId: string, patientId: string): Observable<DataPatientCaseWorkItemModel> {

    if(patientId === null || patientId === undefined || patientId === '' || patientId === 'null') {
      return new Observable<DataPatientCaseWorkItemModel>();
    }

    return this.http.get<DataPatientCaseWorkItemModel>(`/api/get-patient-general-forms-case-work-item/${locId}/${patientId}`);
  }

  updateCaseViewStatusByforms(caseWorkItemFormsId: string, CaseWorkItemId: string): Observable<boolean> {
    return this.http.get<boolean>(`/api/update-case-view-status-by-forms/${caseWorkItemFormsId}/${CaseWorkItemId}`);
  }

  getPatientCases(PatientCaseId: string): Observable<CaseProcedureDataModel[]> {
    const method: string = 'case-procedures';
    const url = environment.TDOurl + method + '/' + PatientCaseId;
    return this.http.get<CaseProcedureDataModel[]>(url, UserService.authorizationHeaderObject);
  }

  getCaseWorkItemsByPatientCaseID(PatientCaseId: string): Observable<DataPatientCaseWorkItemModel[]> {
    const method: string = 'getCaseWorkItemsByPatientCaseID';
    const url = environment.TDOurl + method + '/' + PatientCaseId;
    return this.http.get<DataPatientCaseWorkItemModel[]>(url, UserService.authorizationHeaderObject);
  }

  getCaseWorkItemsByPatientCaseAll(PatientId: string): Observable<DataPatientCaseWorkItemModel[]> {
    const method: string = 'get-case-work-items-by-patient-case-all';
    const url = environment.TDOurl + method + '/' + PatientId;
    return this.http.get<DataPatientCaseWorkItemModel[]>(url, UserService.authorizationHeaderObject);
  }


  addProcedureForExistingCase(PatientCaseId: string, CaseProcedureId: string, toothId: string = null): Observable<any> {
    const payload = {
      CaseProcedureId,
      PatientCaseId,
      ToothID: toothId,
    };

    return this.http.post<any>('/api/cases/addProcedureForExistingCase', payload);
  }

  addProcedureForExistingCaseCaseView(PatientCaseID: string, caseProcedures: cfgCaseProcedure[], toothId: string = null): Observable<any> {
    const payload = {
      PatientId: this.globals.currentPatientId,
      LOCID: this.globals.LOCID,
      CaseProcedureId: null,
      PatientCaseId: PatientCaseID,
      ToothID: toothId,
      CaseProcedures: caseProcedures
    };
    return this.http.post<any>('/api/cases/addProcedureForExistingCase', payload);
  }

  deleteCaseWorkItem(CaseWorkItemID: string): Observable<number> {
    return this.http.post<number>(`/api/cases/deleteCaseWorkItem/${CaseWorkItemID}`, {});
  }

  deleteCaseWorkItemForm(CaseWorkItemFormID: string): Observable<number> {
    return this.http.post<number>(`/api/cases/deleteCaseWorkItemForm/${CaseWorkItemFormID}`, {});
  }

  deleteCaseWorkItemFormTeeth(CaseWorkItemFormID: string): Observable<number> {
    return this.http.post<number>(`/api/cases/deleteCaseWorkItemTeeth/${CaseWorkItemFormID}`, {});
  }


  setCaseWorkItemToCanceled(CaseWorkItemID: string): Observable<number> {
    return this.http.post<number>(`/api/cases/setCaseWorkItemToCanceled/${CaseWorkItemID}`, {});
  }

  setCaseWorkItemFormToCanceled(CaseWorkItemFormID: string): Observable<number> {
    return this.http.post<number>(`/api/cases/setCaseWorkItemFormToCanceled/${CaseWorkItemFormID}`, {});
  }

  addFormsToCaseWorkItem(CaseWorkItemID: string, forms: FormConfigurationModel[], teethIds: string[] = []): Observable<number> {
    return this.http.post<number>(`/api/cases/add-forms-to-case-work-item/${CaseWorkItemID}`, {forms, teethIds});
  }

  setCaseWorkItemTeeth(CaseWorkItemID: string, teeth: cfgTooth[]): Observable<DataPatientCaseWorkItemToothModel[]> {
    return this.http.post<DataPatientCaseWorkItemToothModel[]>(`/api/cases/setCaseWorkItemTeeth/${CaseWorkItemID}`, teeth);
  }

  setCaseWorkItemFormTeeth(CaseWorkItemID: string, CaseWorkItemFormID: string, teeth: cfgTooth[]) {
    return this.http.post<DataPatientCaseWorkItemToothModel[]>(`/api/cases/setCaseWorkItemFormTeeth/${CaseWorkItemID}/${CaseWorkItemFormID}`, teeth);
  }

  setCaseWorkItemFormTeethAfterFormAddition(CaseWorkItemID: string, CaseProcedureFormIDs: string, teeth: cfgTooth[]): Observable<number> {
    return this.http.post<number>(`/api/cases/setCaseWorkItemFormTeethAfterFormAddition/${CaseWorkItemID}/${CaseProcedureFormIDs}`, teeth);
  }

  setCaseWorkItemToInProgress(CaseWorkItemID: string): Observable<number> {
    return this.http.post<number>(`/api/cases/setCaseWorkItemToInProgress/${CaseWorkItemID}`, {});
  }

  setCaseWorkItemFormToStarted(CaseWorkItemFormID: string): Observable<number> {
    return this.http.post<number>(`/api/cases/setCaseWorkItemFormToStarted/${CaseWorkItemFormID}`, {});
  }

  setCaseWorkItemAndFormToStarted(CaseWorkItemID: string, CaseWorkItemFormID: string): Observable<number> {
    return this.http.post<number>(`/api/cases/setCaseWorkItemAndFormToStarted/${CaseWorkItemID}/${CaseWorkItemFormID}`, {});
  }

  handleCaseWorkItemEvent(PassedEvent: PassedPatientCaseWorkItemEventModel): Observable<DataPatientCaseWorkItemEventModel> {
    return this.http.post<DataPatientCaseWorkItemEventModel>('/api/cases/handle-case-work-item-event/', PassedEvent);
  }

  stopAllTimerWatchByPatientCaseId(PatientCaseId: string): Observable<DataPatientCaseWorkItemEventModel[]> {
    return this.http.get<DataPatientCaseWorkItemEventModel[]>(`/api/cases/stop-timer-by-patientcaseId/${PatientCaseId}`);
  }

  createClaimFromCheckOut(claimCreationObj: any): Observable<dataARClaim> {
    return this.http.post<dataARClaim>(`/api/accountReceivable/create-claim-from-check-out`, claimCreationObj);
  }

  setCheckOutComplete(AppointmentId: string) {
    return this.http.get<void>(`api/appointment/check-out-complete/${AppointmentId}`);
  }

  getEventsForWorkItem(workItem: DataPatientCaseWorkItemModel) {
    return this.http.get<DataPatientCaseWorkItemEventModel[]>(`api/cases/get-events-for-work-item/${workItem.CaseWorkItemId}`);
  }

  getEventsForCase(workItem: DataPatientCaseWorkItemModel) {
    return this.http.get<DataPatientCaseWorkItemEventModel[]>(`/api/cases/get-events-for-case/${workItem.CaseWorkItemId}`);
  }

  saveCaseWorkItemTeethSurfaces(CaseWorkItemToothID: string, ToothSurfaceList: string[]): Observable<number> {
    return this.http.post<number>(`/api/cases/save-case-work-item-teeth-surfaces/${CaseWorkItemToothID}`, ToothSurfaceList);
  }
}
